var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { Spin } from "antd";
import { buildWecomAuthorizeUrlResult, clearOauthAttemptFlag, clearWecomOAuthFail, isLikelyWeComWebView, readWecomOAuthFail, rememberPathBeforeWecomOAuthRedirect, } from "./wecomOAuth";
import { getMsOrgApiBaseUrl, resolveApplicationId, verifySessionWithMsOrg, } from "./wecomMsOrgApi";
import { clearWecomMsOrgToken, getWecomMsOrgToken, } from "./tokenStorage";
var FullPageLoading = function (_a) {
    var text = _a.text;
    return (_jsxs("div", __assign({ style: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "100vh",
            gap: 12,
        } }, { children: [_jsx(Spin, { size: "large" }), _jsx("span", __assign({ style: { color: "#666" } }, { children: text }))] })));
};
/**
 * 企微 WebView：无有效 JWT 时跳转 OAuth；有 token 则调 msOrg GET /auth/me 校验。
 */
export var WecomMsOrgAuthGuard = function (_a) {
    var children = _a.children, _b = _a.tokenKey, tokenKey = _b === void 0 ? "token" : _b, _c = _a.tokenStorage, tokenStorage = _c === void 0 ? "both" : _c, deniedFallback = _a.deniedFallback, onDenied = _a.onDenied, applicationId = _a.applicationId, msOrgApiBaseUrl = _a.msOrgApiBaseUrl, wecomRedirectUri = _a.wecomRedirectUri, oauthStatePrefix = _a.oauthStatePrefix, sessionVerifyTimeoutMs = _a.sessionVerifyTimeoutMs;
    var _d = React.useState("checking"), status = _d[0], setStatus = _d[1];
    var _e = React.useState(null), deniedDetail = _e[0], setDeniedDetail = _e[1];
    var onDeniedRef = React.useRef(onDenied);
    onDeniedRef.current = onDenied;
    var clientOpts = React.useMemo(function () { return ({
        applicationId: applicationId,
        msOrgApiBaseUrl: msOrgApiBaseUrl,
        wecomRedirectUri: wecomRedirectUri,
        oauthStatePrefix: oauthStatePrefix,
        sessionVerifyTimeoutMs: sessionVerifyTimeoutMs,
    }); }, [applicationId, msOrgApiBaseUrl, wecomRedirectUri, oauthStatePrefix, sessionVerifyTimeoutMs]);
    var clearFailAndReload = React.useCallback(function () {
        clearWecomOAuthFail();
        window.location.assign("/");
    }, []);
    React.useEffect(function () {
        var run = function () { return __awaiter(void 0, void 0, void 0, function () {
            var fail, token, session, oauthBuild, base, appIdForUrl, selfCheck;
            var _a, _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        fail = readWecomOAuthFail();
                        if (fail) {
                            setDeniedDetail(fail.message);
                            setStatus("denied");
                            (_a = onDeniedRef.current) === null || _a === void 0 ? void 0 : _a.call(onDeniedRef, fail.message);
                            return [2 /*return*/];
                        }
                        token = getWecomMsOrgToken(tokenKey, tokenStorage);
                        if (!token) return [3 /*break*/, 2];
                        return [4 /*yield*/, verifySessionWithMsOrg(token, clientOpts)];
                    case 1:
                        session = _e.sent();
                        if (session.kind === "ok") {
                            clearOauthAttemptFlag();
                            clearWecomOAuthFail();
                            setStatus("ok");
                            return [2 /*return*/];
                        }
                        if (session.kind === "transport_error") {
                            setDeniedDetail(session.message
                                ? "\u65E0\u6CD5\u8FDE\u63A5\u7EC4\u7EC7\u670D\u52A1\u6821\u9A8C\u767B\u5F55\u72B6\u6001\uFF08".concat(session.message, "\uFF09\u3002\u8BF7\u68C0\u67E5\u7F51\u7EDC\u540E\u5237\u65B0\uFF0C\u52FF\u5728\u672A\u5B8C\u6210\u9A8C\u8BC1\u65F6\u81EA\u52A8\u6362\u7968\u8FDB\u5165\u3002")
                                : "无法连接组织服务校验登录状态。请检查网络后刷新。");
                            setStatus("denied");
                            (_b = onDeniedRef.current) === null || _b === void 0 ? void 0 : _b.call(onDeniedRef, (_c = session.message) !== null && _c !== void 0 ? _c : "transport_error");
                            return [2 /*return*/];
                        }
                        clearWecomMsOrgToken(tokenKey, tokenStorage);
                        _e.label = 2;
                    case 2: return [4 /*yield*/, buildWecomAuthorizeUrlResult(clientOpts)];
                    case 3:
                        oauthBuild = _e.sent();
                        if (isLikelyWeComWebView() && oauthBuild.ok) {
                            rememberPathBeforeWecomOAuthRedirect();
                            window.location.replace(oauthBuild.url);
                            return [2 /*return*/];
                        }
                        if (isLikelyWeComWebView() && !oauthBuild.ok) {
                            base = getMsOrgApiBaseUrl(clientOpts);
                            appIdForUrl = resolveApplicationId(clientOpts);
                            selfCheck = appIdForUrl.trim().length > 0
                                ? " \u63A5\u53E3\u81EA\u67E5\uFF1A".concat(base, "/public/wecom-oauth-client/").concat(encodeURIComponent(appIdForUrl.trim()))
                                : "";
                            setDeniedDetail("\u65E0\u6CD5\u53D1\u8D77\u4F01\u5FAE\u6388\u6743\u8DF3\u8F6C\u3002msOrg\uFF1A".concat(oauthBuild.reason) +
                                (oauthBuild.code ? "\uFF08".concat(oauthBuild.code, "\uFF09") : "") +
                                (oauthBuild.httpStatus != null && oauthBuild.httpStatus > 0
                                    ? " [HTTP ".concat(oauthBuild.httpStatus, "]")
                                    : "") +
                                "\u3002\u8BF7\u6838\u5BF9\uFF1A\u2460 \u7EC4\u7EC7\u540E\u53F0\u8BE5\u5E94\u7528\u7684\u300C\u4F01\u5FAE\u5E94\u7528 id\u300D\u5DF2\u586B\u4E14\u5E94\u7528\u4E3A\u542F\u7528\uFF1B\u2461 msOrg \u73AF\u5883\u53D8\u91CF WECOM_CORP_ID\uFF1B\u2462 \u524D\u7AEF\u6784\u5EFA\u7684 applicationId \u4E0E\u5E93\u4E2D applications.id \u4E00\u81F4\u3002" +
                                selfCheck);
                        }
                        setStatus("denied");
                        (_d = onDeniedRef.current) === null || _d === void 0 ? void 0 : _d.call(onDeniedRef, null);
                        return [2 /*return*/];
                }
            });
        }); };
        void run();
    }, [tokenKey, tokenStorage, clientOpts]);
    if (status === "checking")
        return _jsx(FullPageLoading, { text: "\u6B63\u5728\u6821\u9A8C\u4F01\u5FAE\u767B\u5F55\u72B6\u6001..." });
    if (status === "ok")
        return _jsx(_Fragment, { children: children });
    if (deniedFallback !== undefined && deniedFallback !== null) {
        var ctx = { detail: deniedDetail, clearFailAndReload: clearFailAndReload };
        if (typeof deniedFallback === "function") {
            return _jsx(_Fragment, { children: deniedFallback(ctx) });
        }
        return _jsx(_Fragment, { children: deniedFallback });
    }
    return (_jsxs("div", __assign({ style: { padding: 24, textAlign: "center", color: "#666", maxWidth: 520, margin: "0 auto" } }, { children: [_jsx("p", __assign({ style: { marginBottom: 16 } }, { children: deniedDetail || "未登录或登录已失效，请从企微工作台重新进入。" })), deniedDetail ? (_jsx("button", __assign({ type: "button", onClick: clearFailAndReload, style: {
                    padding: "6px 16px",
                    cursor: "pointer",
                    border: "1px solid #d9d9d9",
                    borderRadius: 6,
                    background: "#fff",
                } }, { children: "\u6E05\u9664\u63D0\u793A\u5E76\u91CD\u8BD5" }))) : null] })));
};
